import React from "react";
import { useTranslation } from "react-i18next";
import { View, FlatList } from "react-native";

import CardDocument from "@/components/card/CardDocument";

interface DocumentsProps {
  data: any;
  layer2Id: string;
}

export default function Documents(props: DocumentsProps) {
  const { t } = useTranslation();

  const formatDocumentName = (name: string, id: string) => {
    const words = name.toLowerCase().split("_");
    const docSplit = id.split("-");

    const capitalizedWords = words.map(
      (word) => word.charAt(0).toUpperCase() + word.slice(1),
    );

    return `${docSplit[0]} - ${capitalizedWords.join(" ")}`;
  };

  return (
    <View className="w-full flex-col items-start">
      <View className="flex-wrap flex-row max-w-6xl">
        {props.data
          ?.filter((doc) => doc.azureUrl !== null)
          .map((item) => (
            <CardDocument
              key={item.id}
              layer2Id={props.layer2Id}
              id={item.id}
              text={
                item.document ? formatDocumentName(item.document, item.id) : ""
              }
              url={item.azureUrl}
            />
          ))}
      </View>
    </View>
  );
}
